import { ILearningUpdateStage, ILearningUpdateWorkKind } from 'api/concierge';

export const LEARNING_STAGES = [
    'initialize',
    'snapshot',
    'metadata_nodes',
    'edge_reconciliation',
    'node_contexts',
    'semantic_enrichment',
    'associations_and_conflicts',
    'clarification_consolidation',
    'finalization',
];

export const learningUpdateCount = (value?: number) => Number(value || 0);

export const completedLearningUpdateCount = (item?: ILearningUpdateWorkKind | ILearningUpdateStage) =>
    item
        ? learningUpdateCount(item.succeeded_count) +
          learningUpdateCount(item.partial_count) +
          learningUpdateCount(item.failed_count) +
          learningUpdateCount(item.cancelled_count) +
          learningUpdateCount(item.skipped_count)
        : 0;

/**
 * Stages can overlap when a field in a later stage is ready while unrelated earlier-stage
 * work is still running or retrying. Progress represents the furthest stage reached, not the
 * stage of whichever work item happened to be leased during the latest status poll.
 */
export const furthestReachedLearningStage = (
    currentStage: string | null | undefined,
    stages: ILearningUpdateStage[],
) => {
    let furthestIndex = Math.max(0, LEARNING_STAGES.indexOf(currentStage || ''));
    for (const stage of stages) {
        const stageIndex = LEARNING_STAGES.indexOf(stage.stage);
        const reached = learningUpdateCount(stage.running_count) > 0 || completedLearningUpdateCount(stage) > 0;
        if (reached && stageIndex > furthestIndex) {
            furthestIndex = stageIndex;
        }
    }

    return LEARNING_STAGES[furthestIndex];
};

export const unfinishedEarlierLearningStage = (progressStage: string, stages: ILearningUpdateStage[]) => {
    const progressIndex = LEARNING_STAGES.indexOf(progressStage);
    let unfinishedStage: string | null = null;
    let unfinishedIndex = -1;
    for (const stage of stages) {
        const stageIndex = LEARNING_STAGES.indexOf(stage.stage);
        const unfinished = learningUpdateCount(stage.pending_count) > 0 || learningUpdateCount(stage.running_count) > 0;
        if (unfinished && stageIndex >= 0 && stageIndex < progressIndex && stageIndex > unfinishedIndex) {
            unfinishedStage = stage.stage;
            unfinishedIndex = stageIndex;
        }
    }

    return unfinishedStage;
};
